export default {
    title: "",
    nav: 0,
    navleft: 0,
    ticket: ''
}


// WEBPACK FOOTER //
// ./src/store/state.js